import {
  IFacialRecognition,
  TFacialRecognitionStatus,
  TOnboardingType,
} from 'shared/domain/entities';

type TVectisAuthenticationStatus =
  | 'NAO_ENCONTRADO'
  | 'PROCESSING'
  | 'APPROVED'
  | 'REPROVED'
  | 'PENDING'
  | 'PENDING_OCR';

export type TVectisOnboardingType =
  | 'BIOMETRIA_FACIAL'
  | 'DOCUMENTOSCOPIA'
  | 'BIOMETRIA_FACIAL_ONE_FOR_ONE';

const ONBOARDING_DICTIONARY: Record<TVectisOnboardingType, TOnboardingType> = {
  BIOMETRIA_FACIAL: 'FACIAL_BIOMETRY',
  DOCUMENTOSCOPIA: 'DOCUMENTOSCOPY',
  BIOMETRIA_FACIAL_ONE_FOR_ONE: 'ONE_FOR_ONE_BIOMETRY',
};

const STATUS_DICTIONARY: Record<
  TVectisAuthenticationStatus,
  TFacialRecognitionStatus
> = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  PENDING_OCR: 'PENDING',
  PROCESSING: 'PENDING',
  REPROVED: 'FAILED',
  NAO_ENCONTRADO: 'PENDING',
};

export interface IVectisFacialRecognition {
  url?: string;
  status?: TVectisAuthenticationStatus;
  motivoFalha?: string;
  onboardingEmAndamento: TVectisOnboardingType;
  tiposOnboardingPermitidos?: TVectisOnboardingType[];
  urlRetorno?: string;
}

export class FacialRecognition implements IFacialRecognition {
  public state: IFacialRecognition['state'];
  public onboarding: IFacialRecognition['onboarding'];
  public status: IFacialRecognition['status'];
  public availableOnboardings: IFacialRecognition['availableOnboardings'];
  public returnUrl: IFacialRecognition['returnUrl'];

  constructor({
    url,
    status,
    motivoFalha,
    onboardingEmAndamento,
    tiposOnboardingPermitidos,
    urlRetorno,
  }: IVectisFacialRecognition) {
    this.returnUrl = urlRetorno || undefined;
    this.onboarding = ONBOARDING_DICTIONARY[onboardingEmAndamento];
    this.availableOnboardings =
      tiposOnboardingPermitidos?.map(
        onboarding => ONBOARDING_DICTIONARY[onboarding],
      ) || [];

    if (status) this.status = STATUS_DICTIONARY[status];

    if (url) {
      this.state = {
        type: 'ONBOARDING',
        url,
      };
      return;
    }

    if (this.status === 'APPROVED' || this.status === 'PENDING') {
      this.state = { type: this.status };
      return;
    }

    this.state = {
      type: 'FAILED',
      message: motivoFalha,
    };
  }
}
